export default __webpack_public_path__ + "static/media/programming.13687985.svg";